import { Routes } from '@angular/router';

import {
  AuthGuard,
  AccessGuard
} from '@shared/security';

import {
  LayoutComponent,
  NotfoundComponent,
  UnauthorizedComponent
} from '@theme/layout/index';

import { AuthComponent } from '@salesonepro/auth/auth.component';
import { NoAuthGuard } from '@salesonepro/auth/no-auth-guard.service';

export const AppRoutes: Routes = [
  {
    path: '',
    redirectTo: 'sales',
    pathMatch: 'full',
  },
  {
  path: '',
  component: LayoutComponent,
  canActivate: [ AuthGuard ],
  children: [
    {
      path: 'dashboard',
      loadChildren: () => import('@salesonepro/dashboard/dashboard.module').then(m => m.DashboardModule),
      canLoad: [ AuthGuard ]
    },
    {
      path: 'sales',
      canActivate: [AccessGuard],
      loadChildren: () => import('@salesonepro/sales/sales.module').then(m => m.SalesModule),
      data: {
        acl: 'sales::sales'
      }
    },
    {
      path: 'settings',
      loadChildren: () => import('@salesonepro/settings/settings.module').then(m => m.SettingsModule),
      canActivate: [AccessGuard],
      data: {
        acl: 'settings::settings'
      }
    },
    {
      path: 'work-orders',
      canActivate: [AccessGuard],
      loadChildren: () => import('@salesonepro/production/production.module').then(m => m.ProductionModule),
      data: {
        acl: 'production::production'
      }
    },
    {
      path: 'reports',
      canActivate: [AccessGuard],
      loadChildren: () => import('@salesonepro/reports/reports.module').then(m => m.ReportsModule),
      data: {
        acl: 'reports::reports'
      }
    },
  ]},
  {
    path: 'login',
    component: AuthComponent,
    canActivate: [NoAuthGuard]
  },
  {
    path: '404',
    component: NotfoundComponent,
  },
  {
    path: 'unauthorized',
    component: UnauthorizedComponent,
  },
  {
    path: '**',
    redirectTo: '404',
  },
];
